import TipoNotificacionService from "@/api/services/notificacion/TipoNotificacionService"
import Vue from "vue"

const state = () => ({
    tipos_notificacion: [],
    bd_tables: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "id",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    TIPOS_NOTIFICACION: state => {
        return state.tipos_notificacion
    },
    TIPOS_NOTIFICACION_PAG: state => {
        return state.pagination
    },
    BD_TABLES: state => {
        return state.bd_tables
    }
}

const mutations = {
    SET_TIPOS_NOTIFICACION: (state, payload) => {
        state.tipos_notificacion = payload
    },

    SET_TIPOS_NOTIFICACION_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_TIPO_NOTIFICACION: (state, payload) => {
        state.tipos_notificacion.push(payload)
    },

    UPDATE_TIPO_NOTIFICACION: (state, payload) => {
        state.tipos_notificacion = state.tipos_notificacion.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_TIPO_NOTIFICACION: (state, payload) => {
        state.tipos_notificacion = state.tipos_notificacion.filter(el => el.id !== payload.id)
    },

    SET_BD_TABLES: (state, payload) => {
        state.bd_tables = payload
    }
}

const actions = {
    LOAD_TIPOS_NOTIFICACION: async ({ commit, state }, { filter, tipoNotificacionEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await TipoNotificacionService.get({
                filter,
                tipoNotificacionEstado,
                ...pagination
            })
            if (status === 200) {
                commit("SET_TIPOS_NOTIFICACION", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos de notificación, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_TIPOS_NOTIFICACION: async ({ commit }) => {
        try {
            let { data, status } = await TipoNotificacionService.getAll()
            if (status === 200) {
                commit("SET_TIPOS_NOTIFICACION", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se han podido cargar los tipos de notificación, inténtelo nuevamente"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_TIPOS_NOTIFICACION: async ({ commit }) => {
        try {
            let { data, status } = await TipoNotificacionService.getAllRecords()
            if (status === 200) {
                commit("SET_TIPOS_NOTIFICACION", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos de notificación, inténtelo nuevamente"
            })
        }
    },

    ADD_TIPO_NOTIFICACION: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoNotificacionService.post(payload)
            if (status === 201) {
                commit("ADD_TIPO_NOTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El tipo de notificación ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el tipo de notificación, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_TIPO_NOTIFICACION: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoNotificacionService.put(payload)
            if (status === 200) {
                commit("UPDATE_TIPO_NOTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El tipo de notificación ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el tipo notificación, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_TIPO_NOTIFICACION: async ({ commit }, payload) => {
        try {
            let { status, data } = await TipoNotificacionService.delete(payload)
            if (status === 204) {
                commit("DELETE_TIPO_NOTIFICACION", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El tipo de notificación ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_TIPO_NOTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El tipo de notificación ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el tipo de notificación, inténtelo nuevamente"
            })
        }
    },

    LOAD_BD_TABLES: async ({ commit }) => {
        try {
            let { data, status } = await TipoNotificacionService.loadBdTables()
            if (status === 200) {
                commit("SET_BD_TABLES", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se han podido cargar las tablas de la base de datos, inténtelo nuevamente"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
